// extracted by mini-css-extract-plugin
export var compactFilters = "_ca-4";
export var detailImage = "_ca-1";
export var dropdownContainer = "_ca-2";
export var imageContainer = "_ca-0";
export var selectedCard = "_ca-3";